import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import EmergencyViewPage from "@/pages/EmergencyViewPage";
import RegisterBraceletPage from "@/pages/RegisterBraceletPage";
import ProfilesPage from "@/pages/ProfilesPage";
import BraceletsPage from "@/pages/BraceletsPage";
import EditProfilePage from "@/pages/EditProfilePage";
import QRPrintPage from "@/pages/QRPrintPage";
import FlyerPage from "@/pages/FlyerPage";
import PreRegisterPage from "@/pages/PreRegisterPage";

function App() {
  return (
    <div className="min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/dashboard/profiles" element={<ProfilesPage />} />
          <Route path="/dashboard/bracelets" element={<BraceletsPage />} />
          <Route path="/dashboard/profiles/:profileId/edit" element={<EditProfilePage />} />
          <Route path="/dashboard/print-qr" element={<QRPrintPage />} />
          <Route path="/flyer" element={<FlyerPage />} />
          <Route path="/order" element={<PreRegisterPage />} />
          <Route path="/preregister" element={<PreRegisterPage />} />
          <Route path="/emergency/:braceletCode" element={<EmergencyViewPage />} />
          <Route path="/register-bracelet/:braceletCode" element={<RegisterBraceletPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
